(function () {
    'use strict';

    angular
        .module('app.user')
        .run(appRun);

    appRun.$inject = ['routerHelper'];
    /* @ngInject */
    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [            
            {
                state: 'user.onboard',
                config: {
                    url: '/onboard',                    
                    templateUrl: 'app/user/dashboard/onboard/user.onboard.html',
                    controller: 'UserOnboardController',
                    controllerAs: 'vm',
                    title: 'User Onboarding',                    
                    settings: {
                        isVisible: false,
                        nav: 1,
                        content: '<i class="fa fa-user"></i> User Onboard'
                    }
                }
            },
            {
                state: 'user.edit',
                config: {
                    url: '/onboard/:userId',
                    params: {
                        userId: {
                            value: '0'
                        }
                    },
                    templateUrl: 'app/user/dashboard/onboard/user.onboard.html',
                    controller: 'UserOnboardController',
                    controllerAs: 'vm',
                    title: 'User Onboarding',
                    settings: {
                        isVisible: false,
                        nav: 1,
                        content: '<i class="fa fa-user"></i> User Onboard'
                    }
                }
            },
            {
                state: 'user.pendingEdit',
                config: {
                    url: '/onboard/pending/:pendingId',
                    params: {
                        pendingId: {
                            value: '0'
                        }
                    },
                    templateUrl: 'app/user/dashboard/onboard/user.onboard.html',
                    controller: 'UserOnboardController',
                    controllerAs: 'vm',
                    title: 'User Onboarding',
                    settings: {
                        isVisible: false,
                        nav: 1,
                        content: '<i class="fa fa-user"></i> User Onboard'
                    }
                }
            }
        ];
    }
})();
